/**
 * Lecture de la reponse de GET /v1/application-mobile.
 *
 * Une plateforme peut n'avoir jamais ete publiee : l'ecran doit alors afficher un
 * etat vide explicite plutot qu'un bouton inerte. C'est le seul role de ce module,
 * isole ici pour rester testable hors React.
 */
import i18n from '../../i18n';
import { localeIntl } from '../../i18n/format';

const VIDE = { publie: false };

export function etatPlateforme(liste, plateforme) {
  if (!Array.isArray(liste)) return VIDE;
  const t = (liste || []).find(a => a && a.plateforme === plateforme);
  if (!t) return VIDE;
  return {
    publie: true,
    version: t.version,
    datePublication: t.datePublication,
    notes: t.notesVersion,
    nomFichier: t.nomFichier,
    tailleOctets: t.tailleOctets,
    urlExterne: t.urlExterne,
  };
}

/** Taille lisible. Une taille nulle ou absente n'est pas « 0 o » mais « inconnue ». */
export function formaterTaille(octets) {
  if (!octets || octets <= 0) return '-';
  const mo = octets / (1024 * 1024);
  // Une décimale, sans séparateur de milliers : en français, le même rendu que toFixed(1) à la virgule près.
  const uneDecimale = new Intl.NumberFormat(localeIntl(), { minimumFractionDigits: 1, maximumFractionDigits: 1, useGrouping: false });
  if (mo >= 1) return i18n.t('applicationMobile:taille.mo', { taille: uneDecimale.format(mo) });
  return i18n.t('applicationMobile:taille.ko', { taille: Math.round(octets / 1024) });
}
